<template>

  <t-page>

    <t-dialog-ordained @hidden="getPage"
                       primary-key-column="typeChecklistItemId"
                       foreign-key-column="onlaineId"
                       enable-change-order-up-down
                       v-if="modalOrdained"
                       :path="currentPage.path"
    />

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <b-button-group class="mr-3">

          <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                    :to="currentPage.name + '-form-new'"
                    primary/>

          <t-dropdown variant="outline-primary" icon-settings
                      :items-relation-pages="userAuth.relationPages"/>

        </b-button-group>

        <t-button v-if="userAuth.validation.validationCreate || userAuth.validation.validationUpdate" :text="'Alterar Ordem'"
                  @click="openDialogOrdained()" />

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="typeChecklistItemNumber" link-primary-column="typeChecklistItemCodeLabel"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogOrdained from "@/components/template/dialog/t-dialog-ordained";

export default {
  components: {TDialogOrdained},
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'TypeChecklistItem',

  data() {
    return {
      enableGeneralFields: false,

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'place-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

